import React from 'react';

const ButtonDanger: React.FC<ButtonProps> = ({ text, disabled, onClick }) => (
    <button type="button"
            disabled={disabled}
            onClick={() => onClick? onClick() : undefined}
            className="w-full text-white bg-red-500 hover:bg-fred-red-700 font-semibold rounded-lg text-base px-4 py-4 text-center inline-flex items-center justify-center cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400">
      {text}
    </button>
);

export default ButtonDanger;
